<template>
  <div class="container">
    <div class="live-box" v-if="lists.length > 0">
      <div class="item" v-for="(item, index) in lists" :key="index" @click="goDetail(item.id)">
        <div class="vedio">
          <img
            :src="item.collectStatus == 0 ? require('../../../static/collent.png') : require('../../../static/collent_yello.png')"
            @click.stop="toggle(item)"
            class="shoucang"
            alt=""
          />
          <img class="vedio_picture" :src="baseUrl + item.column15" v-if="item.column15.includes('/hz/hzupload')" />
          <img src="../../../static/占位-活动-列表.png" alt="" v-else />
        </div>

        <div class="title">
          <p>{{ item.actTitle }}</p>

          <p style="color: #666; font-size: 16px;">
            <span><img src="../../../static/ico_time.png" align="absmiddle" alt="" /> </span><span style="margin-left: 5px">{{ item.startTime }}</span>
          </p>

          <p style="font-size: 16px">
            <span> <img src="../../../static/ico_address.png" align="absmiddle"/></span>
            <span style="color: #666; margin-left: 5px;font-weight: 500">{{ item.address }}</span>
            <span style="color: #666;margin-left:5px">{{ $t('common.meetingRoom') }}</span>
          </p>
        </div>

        <!---------公司名称------------>
        <div class="down">
          <p>{{ item.hzExhibitor.companyNameC }}</p>
        </div>
      </div>
    </div>

    <div class="boxImg" v-else>
      <img src="../../../static/empty.png" alt="" />
      <div>{{ $t('search.nodata') }}</div>
    </div>
  </div>
</template>

<script>
import { forMat, backActivityDetail } from '../../../../utils/common.js';
import { getActivityLists, collect } from '../../../../api/recommend.js';

export default {
  data() {
    return {
      baseUrl: forMat(),
      lists: [],
      activityDetailUrl: backActivityDetail(),
    };
  },
  created() {
    this.getLists();
  },
  props: ['flag'],
  methods: {
    goDetail(id) {
      window.location.href = this.activityDetailUrl + '?id=' + id;
    },
    async toggle(item) {
      let status;
      if (item.collectStatus === 0) {
        // 要添加收藏
        status = true;
      } else if (item.collectStatus === 1) {
        status = false;
      }
      const params = {
        objId: item.id,
        flag: status,
        type: 4,
      };
      try {
        const { data } = await collect(params);
        if (data.code === 200) {
          if (item.collectStatus === 0) {
            item.collectStatus = 1;
          } else {
            item.collectStatus = 0;
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getLists() {
      try {
        const { data } = await getActivityLists();
        if (data.code === 200) {
          this.lists = data.data.list;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },

  watch: {
    flag(newName, oldName) {
      this.getLists();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 679px;
  width: 100%;
  .live-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .item {
      width: 286px;
      margin-bottom: 26px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      margin-right: 1%;
      .vedio {
        width: 100%;
        height: 192px;
        border: 1px solid #f1f1f1;
        position: relative;

        .shoucang {
          position: absolute;
          z-index: 9;
          right: 10px;
          top: 10px;
        }
        .vedio_picture {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        box-sizing: border-box;
        height: 117px;
        padding: 20px;
        box-sizing: border-box;
        p {
          margin-top: 5px;
          margin-bottom: 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
      .down {
        border-top: 1px #e0e0e0 solid;
        height: 52px;
        padding-left: 20px;
        padding-bottom: 20px;
        box-sizing: border-box;
        p {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 52px;
          color: #999999;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 380px;
    height: 300px;
  }
}
</style>
